
import { createApp } from 'vue'
import App from './App.vue'
import './style/index.scss'
createApp(App).mount('#app')
